import * as React from 'react';
import ContentStatus from '../../components/ContentStatus';
import { connect } from 'react-redux';
import { Notification } from '../../models/notification/Notification';
import * as DialogStore from '../../store/DialogStore';
import { httpService } from '../../index';
import { ApplicationState } from '../../store';
import * as NotificationStore from '../../store/NotificationStore';
import { DetailsBase } from '../base/DetailsBase';
import DetailsHeader from '../../components/DetailsHeader';
import { Helpers } from '../../utility/Helpers';


class NotificationDetails extends DetailsBase<Notification> {

    constructor(props: any) {
        super(props);
        this.getItem = async (id: string) => {
            let res = await httpService.notificationDetails(id);
            return res;
        }
        this.saveItem = async (data: Notification) => { return await httpService.addOrUpdateNotification(data) }
        this.deleteItemCall = async (id: string) => { return await httpService.notificationDelete(id) }
    }



    render() {
        return (
            <div>
                <DetailsHeader baseUrl="notification" data={this.state.data}
                    title={this.state.data ? this.state.data.title : "Notification Preview"} onDelete={() => {
                        this.deleteItem()
                    }} />

                <ContentStatus isLoading={this.state.isLoading} errorMessage={this.state.error} data={this.state.data}></ContentStatus>
                {(this.state && this.state.data) &&
                    <div>
                        <div className="row">

                            <div className="mb-1 col-md-3">Publish Date:</div>
                            <div className="mb-1 col-md-9"> {this.state.data.publishDate && Helpers.getLocalDateTimeString(this.state.data.publishDate)}</div>

                        </div>
                        <div className="row">

                            <div className="mb-1 col-md-3">Title: </div>
                            <div className="mb-1 col-md-9"> {this.state.data.publishDate && this.state.data.title}</div>

                        </div>
                        
                        <br />
                        {this.state.data.text &&
                            <div>
                                <div>Text</div>

                                <div style={{ border: "1px solid #e9ecef", padding: "20px" }}
                                    dangerouslySetInnerHTML={{ __html: this.state.data.text as string }} />
                            </div>
                        }
                        

                        <br />

                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return { dataState: state.notificationList };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        selectItem: (data: Notification) => { dispatch(NotificationStore.actionCreators.selectItem(data)) },
        getItems: () => { dispatch(NotificationStore.actionCreators.getItems()) },
        increment: () => { dispatch(DialogStore.actionCreators.increment()) },
        decrement: () => { dispatch(DialogStore.actionCreators.decrement()) },
        showNotification: (data: DialogStore.NotificationData) => { dispatch(DialogStore.actionCreators.showNotification(data)) },
        showDialog: (m: string, t: DialogStore.DialogType, cal: Function) => { dispatch(DialogStore.actionCreators.showDialog(m, t, cal)) }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationDetails);
